import { useRef, useEffect } from 'react'

function useClickOutside(onClickOutside) {
  const nodeRef = useRef(null)

  useEffect(() => {
    const handleClick = event => {
      if (nodeRef.current && !nodeRef.current.contains(event.target)) {
        onClickOutside(event)
      }
    }

    const handleEscKey = event => {
      if (event.key === 'Escape') {
        onClickOutside(event)
      }
    }

    document.addEventListener('keydown', handleEscKey)
    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleEscKey)
    }
  }, [onClickOutside])

  return [nodeRef]
}

export default useClickOutside
